import { createReducer } from '../../utils/';
import { combineReducers } from 'redux';
import constant from './constant';

const guestInfo = {
    "name": "",
    "role": 0,
    "token": "",
};

const userInfoHandlers = {
    [constant.LOGIN](state, action) {
        localStorage.setItem('HippoUserInfo', JSON.stringify(action.payload));
        return action.payload;
    },
    [constant.LOGOUT](state, action) {
        localStorage.removeItem('HippoUserInfo');
        return { ...guestInfo };
    },
};

const isAuthenticatedHandlers = {
    [constant.isAuthenticated](state, action) {
        return { ...state, isAuthenticated: action.payload };
    }
};
const uiDutyHandlers = {
    [constant.GETDUTY](state, action) {
        return {...state,  usr: action.payload};
    },
};
export const uiDuty = createReducer({usr:''},uiDutyHandlers);
//console.log(localStorage.getItem('HippoUserInfo'))
//userInfoData = sessionStorage.getItem('HippoUserInfo') ? JSON.parse(sessionStorage.getItem('HippoUserInfo')) : { ...guestInfo };

const userInfo = createReducer({}, userInfoHandlers);
const isAuthenticated = createReducer(false, isAuthenticatedHandlers);

export const login = combineReducers({
    userInfo,
    isAuthenticated,
    uiDuty,
});


// 数据结构
// {

    //redirectToReferrer: false,
    //isAuthenticated: false,

//     userInfo: {
//         "id": "1",
//         "user_name": "admin",
//         "name": "姓名",
//         "phone": "18888888888",
//         "email": "mail@mail.com",
//         "roles": "1",
//         "token": "A1dv8MXha1v5mQrDVOEZ2OJGhmKd0tgiy43In9GnHZ5Rbegmp3M4853o39v9Nlkm3gYn8jwIDz5"
//     }
// }



// WEBPACK FOOTER //
// ./pages/login/reduce.js